import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Shield } from 'lucide-react';
import { FindriscSurvey } from '@/components/FindriscSurvey';
import { Header } from '@/components/Header';

const Index = () => {
  return (
    <div className="min-h-screen bg-gradient-background">
      <Header />
      <div className="container mx-auto px-4 py-8 space-y-12">
        {/* Hero Section */}
        <section className="text-center space-y-6">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-6xl font-bold bg-gradient-primary bg-clip-text text-transparent leading-tight pb-2 overflow-visible">
              Type 2 Diabetes Risk Assessment
            </h1>
            <p className="text-xl md:text-2xl text-muted-foreground max-w-3xl mx-auto">
              Assess your 10-year risk for type 2 diabetes with the Finnish Diabetes Risk Score
            </p>
          </div>
        </section>

        {/* Main Survey */}
        <section>
          <FindriscSurvey />
        </section>


        {/* Disclaimer */}
        <section className="max-w-2xl mx-auto">
          <Card className="bg-secondary/20 border-muted">
            <CardContent className="p-6">
              <div className="space-y-3">
                <h3 className="font-semibold text-sm flex items-center gap-2">
                  <Shield className="h-4 w-4" />
                  Medical Disclaimer
                </h3>
                <p className="text-xs text-muted-foreground">
                  This assessment tool is for informational and educational purposes only and is not intended 
                  as a substitute for professional medical advice, diagnosis, or treatment. The results do not 
                  constitute a medical diagnosis. Always seek the advice of qualified healthcare providers with 
                  questions about your health and before making any healthcare decisions.
                </p>
              </div>
            </CardContent>
          </Card>
        </section>
      </div>
    </div>
  );
};

export default Index;